import { render, staticRenderFns } from "./ticket-settings.vue?vue&type=template&id=176303d4&"
import script from "./ticket-settings.vue?vue&type=script&lang=js&"
export * from "./ticket-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports